import { render, staticRenderFns } from "./AttachmentMetadataDialog.vue?vue&type=template&id=4d9fe9ed&scoped=true&"
import script from "./AttachmentMetadataDialog.vue?vue&type=script&lang=js&"
export * from "./AttachmentMetadataDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentMetadataDialog.vue?vue&type=style&index=0&id=4d9fe9ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9fe9ed",
  null
  
)

export default component.exports